import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import { FaExternalLinkAlt, FaMapMarkerAlt, FaCalendarAlt, FaInfoCircle } from 'react-icons/fa';
import { useI18n } from '../../../i18n';

import './SidePanelDet.css';

const SidePanelDet = (props) => {
    const { t, tStatus } = useI18n();
    const getStatusBadgeClass = (status) => {
        const statusLower = status?.toLowerCase() || '';
        if (statusLower.includes('completed')) return 'status-badge status-completed';
        if (statusLower.includes('wip')) return 'status-badge status-wip';
        if (statusLower.includes('started')) return 'status-badge status-started';
        if (statusLower.includes('accepted')) return 'status-badge status-accepted';
        if (statusLower.includes('created')) return 'status-badge status-created';
        return 'status-badge status-default';
    };

    return (
        <Modal className="dashb modal" show={props.show} onHide={props.hide} animation={true} centered>
            <Modal.Header className="modal-header-custom" closeButton>
                <Modal.Title>
                    <div className="modal-title-wrapper">
                        <h4 className="modal-title-text">{props.title}</h4>
                        <span className="modal-title-count">{props.data.length} {props.data.length === 1 ? t('common.record') : t('common.records')}</span>
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="modal-body-custom">
            {(props.data.length === 0) ? (
              <div className="empty-state">
                <FaInfoCircle className="empty-state-icon" />
                <p className="empty-state-text">{t('users.noRecords')}</p>
              </div>
            ):( 
              <div className="table-wrapper">
                <Table responsive borderless className="modern-table">
                  <thead>
                    <tr>
                      <th className="table-header">{t('common.site')}</th>
                      <th className="table-header">{t('common.address')}</th>										
                      <th className="table-header">{t('common.description')}</th>
                      <th className="table-header">{t('modal.lastUpdate')}</th>
                      <th className="table-header">{t('common.status')}</th>					
                    </tr>
                  </thead>
                  <tbody>				
                    {props.data.map((item, i) => (
                      <tr key={i} className="table-row">
                        <td className="table-cell site-cell">
                          <span 
                            className="site-ref-link" 
                            onClick={() => props.history.push('/task_det/'+ item.taskId )}
                            title={t('modal.viewDetails')}
                          >
                            {item.site_ref}
                            <FaExternalLinkAlt className="external-link-icon" />
                          </span>
                        </td>
                        <td className="table-cell address-cell">
                          <div className="cell-content">
                            <FaMapMarkerAlt className="cell-icon" />
                            <span>{ (item.site_address && item.site_address.length>40) ? item.site_address.substring(0, 40) + '..' : item.site_address  }</span>
                          </div>
                        </td>								
                        <td className="table-cell description-cell">
                          <span>{ (item.fault_description && item.fault_description.length>60) ? item.fault_description.substring(0, 60) + '..' : item.fault_description  }</span>
                        </td>								
                        <td className="table-cell date-cell">
                          <div className="cell-content">
                            <FaCalendarAlt className="cell-icon" />
                            <span className="text-nowrap">{ item.date_upd }</span>
                          </div>
                        </td>		              
                        <td className="table-cell status-cell">
                          <span className={getStatusBadgeClass(item.task_status)}>
                            { tStatus(item.task_status) }
                          </span>
                        </td>
                      </tr>
                    ))}				
                  </tbody>
                </Table>	
              </div>
              )}
            </Modal.Body>
            <Modal.Footer className="modal-footer-custom">
              <Button className="close-button" variant="secondary" onClick={props.hide}>
                {t('common.close')}
              </Button>
            </Modal.Footer>
        </Modal> 
    )
}
     
export default SidePanelDet;
